import { ActionType, action } from 'typesafe-actions';
import { ThunkResult } from '../../typing/types';

export const SET_TUTORIAL_MODE = '@tutorial/SET_TUTORIAL_MODE';
export const SET_QUESTION_TYPE = '@tutorial/SET_QUESTION_TYPE';
export const SHOW_QUESTION_MODAL = '@tutorial/SHOW_TUTORIAL_QUESTION_MODAL';

export const setTutorialMode = (value: boolean) => action(SET_TUTORIAL_MODE, { value });
export const setTutorialQuestionType = (value: string) => action(SET_QUESTION_TYPE, { value });
export const showTutorialQuestionModal = (value: boolean) => action(SHOW_QUESTION_MODAL, { value });

export type TutorialState = {
  isTutorialMode: boolean;
  tutorialQuestionType: string;
  showModalTutorial: boolean;
};

const initialState: TutorialState = {
  isTutorialMode: false,
  tutorialQuestionType: '',
  showModalTutorial: false
};

export const tutorialActions = {
  setTutorialMode,
  setTutorialQuestionType,
  showTutorialQuestionModal
};

export const getStatusDoTutorial = (): ThunkResult => async (dispatch, _getState) => {
  try {
    // tutorial disabled — site details page not supported
  } catch (err) {
    dispatch(tutorialActions.setTutorialMode(false));
  }
};

export const dismissTutorialMode = (): ThunkResult => async (dispatch, _getState) => {
  try {
    await dispatch(tutorialActions.setTutorialMode(false));
  } catch (err) {
    dispatch(tutorialActions.setTutorialMode(false));
  }
};

export const tutorialThunks = {
  getStatusDoTutorial,
  dismissTutorialMode
};

export type TutorialAction = ActionType<typeof tutorialActions>;

export function tutorialReducer(state: TutorialState = initialState, incomingAction: TutorialAction): TutorialState {
  switch (incomingAction.type) {
    case SHOW_QUESTION_MODAL: {
      return {
        ...state,
        showModalTutorial: incomingAction.payload.value
      };
    }
    case SET_TUTORIAL_MODE: {
      return {
        ...state,
        isTutorialMode: incomingAction.payload.value
      };
    }
    case SET_QUESTION_TYPE: {
      return {
        ...state,
        tutorialQuestionType: incomingAction.payload.value
      };
    }
    default:
      return state;
  }
}
